<template>
  <div id="create-study-set-overview">
    <div class="base-create">
      <div>
        <el-row class="mb-px-16">
          <el-col :span="8">
            <div class="info-row">
              <p>
                <span class="label">{{$t($i18nLabelsHelper(currentOrganizationType, `teacher`))}}:</span> <span class="value">{{ studysetDetails.owner_name }}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-row">
              <p>
                <span class="label">{{$t(`study_sets.table.shareable_to`)}}:</span> <span class="value">{{ $t($i18nLabelsHelper(currentOrganizationType, `study_sets.${studysetDetails.shareable}`)) }}</span>
              </p>
            </div>
          </el-col>
        </el-row>
        <el-row class="mb-px-16">
          <el-col :span="8">
            <div class="info-row">
              <p>
                <span class="label">{{$t(`study_sets.table.last_updated`)}}:</span> <span class="value"> {{ formatDate(studysetDetails.updated_at) }}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-row">
              <p>
                <span class="label">{{$t($i18nLabelsHelper(currentOrganizationType, `study_sets.assigned_groups`))}}:</span> <span class="value">{{ assigned_group.length }}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-row">
              <p>
                <span class="label">{{$t(`study_sets.phrases_count`)}}:</span> <span class="value">{{ studysetDetails.phrases_count }}</span>
              </p>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="phrases-wrapper">
              <div class="info-row mb-px-16">
                <p><span class="label">{{$t(`study_sets.phrases`)}}</span></p>
              </div>
              <ul class="phrases-list list-none" v-if="studysetDetails">
                <li v-for="item in getItemsOfStudySet(studysetDetails)" :key="item.id">
                  <el-tooltip content="This phrase was successfully added" placement="top-start"></el-tooltip>
                  <el-row type="flex" :gutter="24" class="item">
                      <el-col :span="16">
                      {{ item.name }}
                      </el-col>
                      <el-col v-for="skill in item.skills" :key="skill" :span="2">
                        <i :class="`elsa-skill-` + skill" />
                      </el-col>
                  </el-row>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
// import Chip from "@/components/common/Chip";
import { pathOr, isNil, compose, propOr, length } from 'ramda'
import { mapActions, mapGetters } from 'vuex'
import { memberships } from '@/helpers/memberships'
import { DefaultShareableOptions } from '@/constants/studySets'
import { getOptionsLabels } from '@/utils/elementUi'
import { format } from 'date-fns'
import { DATE_FORMAT } from "@/constants/generic"
import { STUDY_SET_SKILLS } from "@/constants/studySets"

export default {
  components: {},
  props: {
    studysetDetails: {},
    organizationType: {},
    editClass: {
      type: Function,
      default: () => {}
    },
    showEditClass: {
      type: Boolean,
      default: true
    },
    showUserInfo: {
      type: Boolean,
      default: true
    },
    organizationId: {},
    uploadId: {
      default: null
    },
    dateFormat: {
      type: String,
      default: DATE_FORMAT
    }
  },
  data() {
    return {
      showStudentsModal: false,
      showImportModal: false,
      uploadDetails: {}
    }
  },
  computed: {
    startEndDate() {
      const not_selected = this.$t('classes.create_class_flow.class_overview.not_selected')
      const start_date = isNil(this.studysetDetails.startDate) ? not_selected : new Date(this.studysetDetails.startDate).toDateString()
      const end_date = isNil(this.studysetDetails.endDate) ? not_selected : new Date(this.studysetDetails.endDate).toDateString()

      return `${start_date} - ${end_date}`
    },
    classId() {
      return pathOr(null, ['studysetDetails', 'id'])(this)
    },
    ...mapGetters({
      isTeacher: 'organization/isOrganizationTeacher',
      isAdmin: 'organization/isOrganizationAdmin',
      isAssociateAdmin: 'organization/isOrganizationAssociateAdmin',
      currentUser: 'user/getUser',
      currentOrganizationType: 'organization/currentOrganizationType'
    }),
    assigned_group() {
      return this.studysetDetails &&this.studysetDetails.assigned_group? this.studysetDetails.assigned_group: [];
    },
    isTeacherAndAdmin() {
      return this.isAdmin || !this.isTeacher
    },
    users() {
      // if (this.uploadId) {
      //   return compose(
      //     map(objOf("text")),
      //     pathOr([], ["uploadDetails", "emails"])
      //   )(this);
      // }
      return pathOr([], ['studysetDetails', 'users'])(this)
    },
    numberOfUsers: compose(length, propOr([], 'users'))
  },
  methods: {
    getShareableLabel(v) {
      return getOptionsLabels(DefaultShareableOptions, v)
    },
    getNameMembership(membership_id) {
      if (membership_id in memberships) {
        return memberships[membership_id]['full_name']
      }
      return ''
    },
    formatDate(date) {
      return date ? format(new Date(date), this.dateFormat) : '--'
    },
    getItemsOfStudySet(studySet) {
      if (!studySet || !studySet.phrases || !studySet.items) {
        return 0
      }
      let items = [];
      if(studySet.items.length > 0) {
        studySet.items.forEach(item => {
          items.push({"name": item.name, "skills": item.skills_support})
        });
      } else {
        studySet.phrases.forEach(phrase => {
          items.push({"name": phrase.text, "skills": [STUDY_SET_SKILLS.SPEAKING]})
        });
      }
      return items;
    },
    ...mapActions('invite', ['postSentInviteUploadEmails', 'patchInviteUploadEmails', 'getInviteUploadEmails'])
  },
  watch: {
    // uploadId: {
    //   immediate: true,
    //   deep: true,
    //   async handler(newUploadId) {
    //     if (newUploadId) {
    //       const response = await this.getInviteUploadEmails({
    //         uploadId: this.uploadId
    //       });
    //       this.uploadDetails = propOr([], "data")(response);
    //     }
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';
h3 {
  text-transform: none;
}
.class-teacher {
  margin-top: 40px;
  .user-info {
    display: flex;
    flex-direction: column;
    .name {
      color: $black;
    }
  }
}
p {
  font-weight: 300;
  font-size: 18px;
  color: $dark-blue-2;
  margin: 0;
}
.practice {
  display: flex;
  align-items: center;
  margin-top: 24px;
  .input-wrapper {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: $black;
    .goal-value {
      font-weight: bold;
      font-size: 20px;
      color: #478dff;
      padding: 0 5px;
    }
  }
  .description {
    p {
      margin-top: 5px;
      font-size: 16px;
      line-height: 24px;
      opacity: 0.7;
    }
    .assessment-test-title {
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
      color: $black;
      opacity: 1;
    }
  }
  .box-card {
    border: 1px solid #e6e6e6;
    box-sizing: border-box;
    border-radius: 16px;
    // margin-bottom: 24px;
    height: 214px;
    width: 100%;
    ::v-deep .el-card__body {
      align-items: flex-start;
      .card-number {
        margin-bottom: 8px;
      }
      .card-content {
        flex: 1 0;

        h2 {
          font-size: 24px;
          line-height: 36px;
          color: #121131;
        }

        p {
          font-size: 16px;
          line-height: 24px;
          color: #121131;
        }

        button {
          float: right;
        }
      }
    }
  }
}
.line-separate {
  border: 1px solid#E6E6E6;
  margin: 40px 0 32px;
}

#create-study-set-overview {
  background: #ffffff;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 24px 32px;
  margin-bottom: 24px;
}

.info-row {
  p {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #757575;
    margin: 0;
    text-align: initial;
  }

  .value {
    color: $black;
    text-transform: none;
    margin-bottom: 4px;
  }

  // .values {
  //   margin-top: 5px;
  //   p {
  //     color: $black;
  //     text-transform: none;
  //     margin-bottom: 4px;
  //     font-weight: 500;
  //   }
  // }
  // p {
  //   font-weight: 600;
  //   font-size: 17px;
  //   color: $dark-blue-2;
  //   margin: 0;
  //   text-align: initial;
  //   text-transform: capitalize;
  // }
}

.phrases-wrapper {
  background: #f1f1f1;
  border-radius: 8px;
  padding: 16px;

  // &::-webkit-scrollbar {
  //   width: 10px;
  // }

  // &::-webkit-scrollbar-track {
  //   background-color: #edf4ff;
  //   border-radius: 100px;
  // }

  // &::-webkit-scrollbar-thumb {
  //   box-shadow: inset 0 0 8px #c2c2c2;
  //   border-radius: 100px;
  // }
}

.phrases-list {
  overflow: auto;
  height: 250px;
  padding-left: 0px;
  margin-top: 12px;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  padding: 0;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #edf4ff;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c2c2c2;
    // box-shadow: inset 0 0 8px #C2C2C2;
    border-radius: 100px;
  }
  .item {
    width: 100%;
  }
}

.phrases-list li {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  color: #121131;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
}
</style>
